import loginPage from '../pages/Login.vue'
import notFoundPage from '../pages/NotFound.vue'
import dashboardPage from '../pages/dashboard/DashboardPage.vue'
import outletPage from '../pages/outlet/OutletPage.vue'
import paymentMethodPage from '../pages/paymentMethod/PaymentMethodPage.vue'
import sellerPage from '../pages/seller/SellerPage.vue'
import productPage from '../pages/products/ProductPage.vue'
import registerPage from '../pages/register/RegisterPage.vue'
import cashierPage from '../pages/cashier/CashierPage.vue'
import sellReportPage from '../pages/sellReport/SellReportPage.vue'
import totalRevenuePage from '../pages/totalRevenue/TotalRevenuePage.vue'
import revenueByPaymentPage from '../pages/totalRevenueByPayment/RevenueByPaymentPage.vue'
import revenueByCustomerPage from '../pages/revenueByCustomer/RevenueByCustomerPage.vue'
import revenueByOutletPage from '../pages/revenueByOutlet/RevenueByOutletPage.vue'
import refundPage from '../pages/refund/RefundPage.vue'
import discountPage from '../pages/discount/DiscountPage.vue'
import fulfillmentPage from '../pages/fulfillment/FulfillmentPage.vue'
import orderByOrderStatusPage from '../pages/orderStatus/OrderByOrderStatusPage.vue'
import orderByPaymentStatusPage from '../pages/paymentStatus/OrderByPaymentStatusPage.vue'
import averageDurationPage from '../pages/averageDuration/AverageDurationPage.vue'
import averageOrderValuePage from '../pages/averageOrderValue/AverageOrderValuePage.vue'
import averageOrderValueByPaymentPage from '../pages/averageOrderValueByPayment/AverageOrderValueByPaymentPage.vue'
import numberOfOrdersPage from '../pages/numberOfOrder/NumberOfOrdersPage'
import numberOfOrdersByPaymentPage from '../pages/numberOfOrderByPayment/NumberOfOrdersByPaymentPage.vue'
import netRevenuePage from '../pages/netRevenue/NetRevenuePage'
import globalPage from '../pages/global/GlobalPage'
import revenueByCategoryPage from '../pages/revenueByCategory/RevenueByCategoryPage'
import averageItemPerOrderPage from '../pages/averageItemPerOrder/AverageItemPerOrderPage'
import taxPage from '../pages/tax/taxPage'
import productSoldPage from '../pages/productSold/ProductSoldPage'
import revenueByProduct from '../pages/revenueByProduct/revenueByProductPage'
import productSoldByCategoryPage from '../pages/productSoldByCategory/ProductSoldByCategoryPage'
import timeInStatusPage from '../pages/timeInStatus/TimeInStatusPage.vue'
import tippings from '../pages/tippings/Tippings.vue'
import salesOrder from '../pages/salesOrder/SalesOrderPage.vue'

import { DOMAIN_TITLE } from '../.env'
import DailyReportPage from '@/pages/dailyReport/DailyReportPage.vue'
import MonthlyReportPage from '@/pages/monthlyReport/MonthlyReportPage.vue'

const getTitleByDomain = () => {
  const domain = window.location.hostname
  switch (domain) {
    case 'daily.shopsavvypos.com':
      return `Shop Savvy - ${DOMAIN_TITLE}`
    default:
      return DOMAIN_TITLE
  }
}

export const routes = [
  {
    path: '/',
    name: 'index',
    redirect: { name: 'dashboard' },
    meta: { title: `${getTitleByDomain()} | home`, requireLogin: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboardPage,
    meta: { title: `${getTitleByDomain()} | dashboard`, requireLogin: true }
  },
  {
    path: '/product',
    name: 'product',
    component: productPage,
    meta: { title: `${getTitleByDomain()} | product`, requireLogin: true }
  },
  {
    path: '/seller',
    name: 'seller',
    component: sellerPage,
    meta: { title: `${getTitleByDomain()} | seller`, requireLogin: true }
  },
  {
    path: '/outlet',
    name: 'outlet',
    component: outletPage,
    meta: { title: `${getTitleByDomain()} | outlet`, requireLogin: false }
  },
  {
    path: '/payment',
    name: 'payment',
    component: paymentMethodPage,
    meta: { title: `${getTitleByDomain()} | payment`, requireLogin: true }
  },
  {
    path: '/register',
    name: 'register',
    component: registerPage,
    meta: { title: `${getTitleByDomain()} | register`, requireLogin: true }
  },
  {
    path: '/cashier',
    name: 'cashier',
    component: cashierPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/total-revenue',
    name: 'totalRevenue',
    component: totalRevenuePage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/total-revenue-payment-date',
    name: 'total-revenue-payment-date',
    component: revenueByPaymentPage,
    meta: { title: `${getTitleByDomain()} | revenue - payment date`, requireLogin: true }
  },
  {
    path: '/revenue-by-customer',
    name: 'revenueByCustomer',
    component: revenueByCustomerPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/revenue-by-outlet',
    name: 'revenueByOutlet',
    component: revenueByOutletPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/refund',
    name: 'refund',
    component: refundPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/discount',
    name: 'discount',
    component: discountPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/fulfillment',
    name: 'fulfillment',
    component: fulfillmentPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/average-order-value',
    name: 'averageOrderValue',
    component: averageOrderValuePage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/average-order-value-payment-date',
    name: 'average-order-value-payment-date',
    component: averageOrderValueByPaymentPage,
    meta: { title: `${getTitleByDomain()} | average order - payment date`, requireLogin: true }
  },
  {
    path: '/number-of-orders',
    name: 'numberOfOrders',
    component: numberOfOrdersPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/number-of-orders-payment-date',
    name: 'number-of-orders-payment-date',
    component: numberOfOrdersByPaymentPage,
    meta: { title: `${getTitleByDomain()} | order count - payment date`, requireLogin: true }
  },
  {
    path: '/order-status',
    name: 'orderStatus',
    component: orderByOrderStatusPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/payment-status',
    name: 'paymentStatus',
    component: orderByPaymentStatusPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/average-duration',
    name: 'averageDuration',
    component: averageDurationPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/time-in-status',
    name: 'timeInStatus',
    component: timeInStatusPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/tippings',
    name: 'tippings',
    component: tippings,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/sales-order',
    name: 'salesOrder',
    component: salesOrder,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/global',
    name: 'global',
    component: globalPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/global-stores',
    name: 'global-stores',
    component: globalPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/net-revenue',
    name: 'netRevenue',
    component: netRevenuePage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/revenue-by-category',
    name: 'revenueByCategory',
    component: revenueByCategoryPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/average-item-per-order',
    name: 'averageItemPerOrder',
    component: averageItemPerOrderPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/tax',
    name: 'tax',
    component: taxPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/product-sold',
    name: 'productSold',
    component: productSoldPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/revenue-by-product',
    name: 'revenueByProduct',
    component: revenueByProduct,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  {
    path: '/product-sold-by-category',
    name: 'productSoldByCategory',
    component: productSoldByCategoryPage,
    meta: { title: `${getTitleByDomain()} | cashier`, requireLogin: true }
  },
  { path: '/sales-report', name: 'salesReport', component: sellReportPage, meta: { title: `${getTitleByDomain()} | sales report`, requireLogin: true } },
  { path: '/daily-report', name: 'dailyReport', component: DailyReportPage, meta: { title: `${getTitleByDomain()} | daily report`, requireLogin: true } },
  { path: '/monthly-report', name: 'monthlyReport', component: MonthlyReportPage, meta: { title: `${getTitleByDomain()} | monthly report`, requireLogin: true } },
  {
    path: '/login',
    name: 'login',
    component: loginPage,
    meta: { title: `${getTitleByDomain()} | login`, authLayout: true }
  },
  {
    path: '*',
    component: notFoundPage,
    meta: { title: `${getTitleByDomain()} | not found` }
  }
]
